/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The GenerateVoucherResponse model module.
 * @module model/GenerateVoucherResponse
 * @version 1.0
 */
class GenerateVoucherResponse {
    /**
     * Constructs a new <code>GenerateVoucherResponse</code>.
     * @alias module:model/GenerateVoucherResponse
     * @param success {Boolean} 
     * @param voucherType {module:model/GenerateVoucherResponse.VoucherTypeEnum} 
     */
    constructor(success, voucherType) { 
        
        GenerateVoucherResponse.initialize(this, success, voucherType);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, success, voucherType) { 
        obj['success'] = success;
        obj['voucher_type'] = voucherType;
    }

    /**
     * Constructs a <code>GenerateVoucherResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GenerateVoucherResponse} obj Optional instance to populate.
     * @return {module:model/GenerateVoucherResponse} The populated <code>GenerateVoucherResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GenerateVoucherResponse();

            if (data.hasOwnProperty('success')) {
                obj['success'] = ApiClient.convertToType(data['success'], 'Boolean');
            }
            if (data.hasOwnProperty('voucher_type')) {
                obj['voucher_type'] = ApiClient.convertToType(data['voucher_type'], 'String');
            }
            if (data.hasOwnProperty('voucher_code')) {
                obj['voucher_code'] = ApiClient.convertToType(data['voucher_code'], 'String');
            }
            if (data.hasOwnProperty('cart_url')) {
                obj['cart_url'] = ApiClient.convertToType(data['cart_url'], 'String');
            }
            if (data.hasOwnProperty('cart_id')) {
                obj['cart_id'] = ApiClient.convertToType(data['cart_id'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Boolean} success
 */
GenerateVoucherResponse.prototype['success'] = undefined;

/**
 * @member {module:model/GenerateVoucherResponse.VoucherTypeEnum} voucher_type
 */
GenerateVoucherResponse.prototype['voucher_type'] = undefined;

/**
 * @member {String} voucher_code
 */
GenerateVoucherResponse.prototype['voucher_code'] = undefined;

/**
 * @member {String} cart_url
 */
GenerateVoucherResponse.prototype['cart_url'] = undefined;

/**
 * @member {Number} cart_id
 */
GenerateVoucherResponse.prototype['cart_id'] = undefined;





/**
 * Allowed values for the <code>voucher_type</code> property.
 * @enum {String}
 * @readonly
 */
GenerateVoucherResponse['VoucherTypeEnum'] = {

    /**
     * value: "free"
     * @const
     */
    "free": "free",

    /**
     * value: "general_voucher"
     * @const
     */
    "general_voucher": "general_voucher",

    /**
     * value: "new_student_voucher"
     * @const
     */
    "new_student_voucher": "new_student_voucher"
};



export default GenerateVoucherResponse;

